import { Project } from "src/@types/basket";
import axiosInstance from "../utils/axios";
import { DEFAULT_CURRENCY } from "src/utils/priceFormatter";

//
//

const BASKETS_URL = 'projects/baskets/v2/';

//

function getBasketsApi(codes?: string[], includePublic?: boolean, currency?: string, merchantCode?: string) {
    const params: { codes?: string[], includePublic?: boolean, currency?: string, merchantCode?: string } = {};

    const currencyParam = currency ? currency : DEFAULT_CURRENCY;

    if(includePublic)
        params.includePublic = includePublic;
    if(codes)
        params.codes = codes;
    if(merchantCode)
        params.merchantCode = merchantCode;

    return axiosInstance.get(`projects/baskets/v2?currency=${currencyParam}&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`, {
        params,
        paramsSerializer: params => {
            return `${codes ? params.codes.map((code: any) => 
                `codes=${code}`).join('&') : ''}${params.includePublic ? `&includePublic=${params.includePublic}` : ''}${params?.merchantCode ? `&merchantCode=${params.merchantCode}` : ''}`
        }
    })
}

export const getBasketByCode = async (code?: string | null) => {
    if (!code) return;

    try {
      return await axiosInstance.get(`${BASKETS_URL}${code}?fields=estimatedUnitPrice`);
    } catch (error) {
      console.error(`Failed to get basket by code: ${code}`, error);
      throw error;
    }
};

type GetPreferredBasketPayload = {
    merchantCode: string;
    programmeCode?: string;
    currency?: string;
}

export const getPreferredBasket = async (payload: GetPreferredBasketPayload) => {
    try {
        const response = await axiosInstance.get(`${BASKETS_URL}preferred?fields=estimatedUnitPrice`, { params: { ...payload } });
        return response?.data;
    } catch (error) {
      console.error(`Failed to get preferred basket for merchant code: ${payload?.merchantCode}`, error);
      throw error;
    }
};

function getBasketByIdApi(id: string, currency?: string) {
    const currencyParam = currency ? currency : DEFAULT_CURRENCY;

    return axiosInstance.get(
        `${BASKETS_URL}${id}?currency=${currencyParam}&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`
    );
}

function getProjectByCodeApi(code: string, currency?: string){
    let queryArray = [];

    if (currency) queryArray.push("unitPriceCurrency=" + currency);

    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";

    return axiosInstance.get(`projects/v2/${code}${queryString}`)
}

export const getProjectByCodeAPI = async (params: { code: string, currency?: string }, options?: any): Promise<any> => {
    const { code, ...query } = params;

    const response = await axiosInstance.get<Project>(`projects/v2/${code}`, {
      params: query, // query params
    });
  
    if (!response.data) throw new Error('Unexpected API response');
  
    return response.data;
};

function getProjectsApi(
    countryCode?: string | null,
    locale?: string,
    filteredOptions?: any,
    currency?: string,
) {
    let queryArray = [];
    if (locale) queryArray.push("locale=" + locale);
    if (countryCode) queryArray.push("countryCode="+countryCode);
    if (currency) queryArray.push("currency=" + currency);
    if (filteredOptions?.regions) queryArray.push("regions="+filteredOptions?.regions);
    if (filteredOptions?.methodCategory) queryArray.push("methodCategories="+filteredOptions?.methodCategory);
    if (filteredOptions?.registry) queryArray.push("registryCodes="+filteredOptions?.registry);
    if (filteredOptions?.projectIds) {
        filteredOptions.projectIds.forEach((id: string) => queryArray.push("projectIds="+id))
    }
    if (filteredOptions?.statuses) {
        filteredOptions.statuses.forEach((s: string) => queryArray.push("statuses="+s))
    }
    if (filteredOptions?.goalNums) {
        filteredOptions.goalNums.forEach((n: string) => queryArray.push("goalNums="+n))
    }
    // searches all text fields; including highlights
    if (filteredOptions?.searchTerm) queryArray.push("searchTerm="+filteredOptions?.searchTerm);
    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";

    return axiosInstance.get(`projects/v2/${queryString}`)
}

export {
    getBasketsApi,
    getBasketByIdApi,
    getProjectByCodeApi,
    getProjectsApi,
};